export const useScrollToTop = () => {
  const scrollToTop = () => {
    if (process.client) {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  return { scrollToTop }
}